import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { environment } from '../../environments/environment';
import {
  GlAccountRule,
  GlAccountRuleInsert,
  GlAccountRulePreview,
  GlAccountRulePreviewCommand,
  GlAccountRuleResolution,
  GlAccountRuleResolveCommand,
  GlAccountRuleSearchCommand,
  GlAccountRuleUpdate,
} from '../models/gl-account-rule/gl-account-rule';
import { PagedResult } from './bank-account.proxy.service';

@Injectable({ providedIn: 'root' })
export class GlAccountRuleProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/gl-account-rule';

  public search(
    command: GlAccountRuleSearchCommand,
    pageNumber: number,
    pageSize: number,
    sortField: string | null = null,
    sortOrder = -1,
  ): Observable<ApiResponse<PagedResult<GlAccountRule>>> {
    let params = new HttpParams().set('pageNumber', pageNumber).set('pageSize', pageSize).set('sortOrder', sortOrder);
    if (sortField) params = params.set('sortField', sortField);
    return this.httpClient.post<ApiResponse<PagedResult<GlAccountRule>>>(`${this.baseUrl}/search`, command, { params });
  }

  /** Batch: the winning rule and account for each line; unresolved lines come back with nulls. */
  public resolve(command: GlAccountRuleResolveCommand): Observable<ApiResponse<GlAccountRuleResolution[]>> {
    return this.httpClient.post<ApiResponse<GlAccountRuleResolution[]>>(`${this.baseUrl}/resolve`, command);
  }

  /** Dry run (#5784): which cost centers an unsaved rule would take and which rules it would replace. */
  public preview(command: GlAccountRulePreviewCommand): Observable<ApiResponse<GlAccountRulePreview>> {
    return this.httpClient.post<ApiResponse<GlAccountRulePreview>>(`${this.baseUrl}/preview`, command);
  }

  public create(payload: GlAccountRuleInsert): Observable<ApiResponse<GlAccountRule>> {
    return this.httpClient.post<ApiResponse<GlAccountRule>>(this.baseUrl, payload);
  }

  public update(id: string, payload: GlAccountRuleUpdate): Observable<ApiResponse<GlAccountRule>> {
    return this.httpClient.put<ApiResponse<GlAccountRule>>(`${this.baseUrl}/${id}`, payload);
  }
}
